<template>
  <div class="acw-card">
    <div v-if="workflow" class="d-flex align-items-center justify-content-between flex-wrap gap-2">
      <div class="acw-info">
        <div class="acw-name">{{ name }}</div>
        <span class="badge px-3 py-1 border-radius-sm" :class="statusClass">{{ $t(statusKey) }}</span>
      </div>
      <router-link :to="editLink" class="btn btn-sm btn-outline-primary mb-0">
        {{ $t('Assistant.Widget.Automation.Edit') }}
      </router-link>
    </div>
    <div v-else class="acw-empty">{{ $t('Assistant.Widget.Unsupported', { type: 'automation' }) }}</div>
  </div>
</template>

<script>
// Renders the workflow object returned by create/update/publish/unpublish/get_automation as a
// small card (name + status + link), reusing the same status labels/colors as the Automations
// list page (WorkflowsList.vue), so the chat and the dashboard never disagree on what a status means.
const STATUS_MAP = {
  0: { class: 'bg-gradient-secondary', key: 'Workflows.Status.Draft' },
  1: { class: 'bg-gradient-success', key: 'Workflows.Status.Active' },
  2: { class: 'bg-gradient-warning', key: 'Workflows.Status.Stopped' },
  3: { class: 'bg-gradient-dark', key: 'Workflows.Status.Archived' },
  4: { class: 'bg-gradient-danger', key: 'Workflows.Status.Error' },
}

export default {
  name: 'AutomationCardWidget',
  props: {
    data: { type: Object, required: true },
  },
  computed: {
    workflow() {
      return this.data?.workflow ?? null
    },
    name() {
      return this.workflow?.name || this.$t('Assistant.Widget.Automation.Untitled')
    },
    statusEntry() {
      return STATUS_MAP[this.workflow?.status] || { class: 'bg-light text-dark', key: 'Workflows.Status.Draft' }
    },
    statusClass() {
      return this.statusEntry.class
    },
    statusKey() {
      return this.statusEntry.key
    },
    editLink() {
      return {
        name: 'WorkflowCanvas',
        params: { wid: this.workflow.id, wvid: this.workflow.active_version_id || undefined },
      }
    },
  },
}
</script>

<style scoped>
.acw-card {
  width: 100%; padding: 12px 16px; border: 1px solid var(--ui-border); border-radius: var(--radius-lg);
  background: var(--ui-bg-card);
}
.acw-info { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.acw-name { font: 600 13px 'Open Sans', sans-serif; color: var(--ui-text-1); }
.acw-empty {
  display: flex; align-items: center; justify-content: center; min-height: 40px;
  font: 500 12px 'Open Sans', sans-serif; color: var(--ui-text-3);
}
</style>
